<template>
  <div class="collapsible-fieldset">
    <div class="header"
         :href="'#' + _uid"
         v-bind:class="{editing: isEditing, visible: isExpanded}">
      <span class="title">
        {{title}}
      </span>
      <button class="editor top"
              @click="startEditing"
              v-if="!isEditing && isExpanded">
        Make a Revision
      </button>
      <span v-if="isEditing">You are in revision mode.</span>
      <button class="toggler"
              @click="toggleExpanded"
              v-if="!isEditing">
        <font-awesome-icon icon="chevron-down"/>
      </button>
    </div>
    <div v-bind:class="{collapse: !isExpanded}" :id="_uid">
      <div class="content">
        <div class="gutter"></div>
        <div class="w-100">
          <fieldset v-bind:disabled="!isEditing">
            <slot></slot>
          </fieldset>
          <button class="editor bottom"
                  @click="editingState = true"
                  v-if="!isEditing && isExpanded">
            Make a Revision
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CollapsibleFieldset',
  props: {
    title: String,
    expanded: Boolean,
    editing: Boolean,
  },
  data() {
    return {
      expandedState: null,
      editingState: null,
    };
  },
  methods: {
    toggleExpanded() {
      this.expandedState = !this.isExpanded;
    },
    startEditing() {
      this.editingState = true;
      this.$emit('update:editing', true);
    },
  },
  computed: {
    isExpanded() {
      if (this.expandedState == null) {
        return this.expanded;
      }
      return this.expandedState;
    },
    isEditing() {
      if (this.editingState == null) {
        return this.editing;
      }
      return this.editingState;
    },
  },
};
</script>

<style scoped>
  fieldset {
    margin: 0;
    border: none;
  }
</style>
